import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <ContactSection />
        <FeaturesSection />
        <CardsSection />
        <AboutSection />
        <TopicsSection />
        <AppSection />
        <UpdatesSection />
        <RankingSection />
        <CommentsSection />
        <MediaSection />
        <FAQSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}